<div class="otp-container" (paste)="onPaste($event)">
  <div class="otp-wrapper">
    <div class="otp-inputs">
      <input
        *ngFor="let i of [0,1,2,3,4,5]"
        #otpInput
        matInput
        type="text"
        maxlength="1"
        [formControl]="getDigitControl(i)"
        (input)="onInput($event, i)"
        (keydown)="onKeyDown($event, i)"
        (focus)="onFocus(i)"
        (blur)="onBlur()"
        [placeholder]="placeholder()"
        class="otp-input"
        [class.error]="error()"
      />
    </div>
    @if (error()) {
      <mat-error class="error-message">{{ error() }}</mat-error>
    }
  </div>
  <div class="flex w-full justify-center items-center text-[#414651] font-regular font-geist text-[12px] mb-4">
    The code expires in 10 minutes
  </div>
</div>
